import { Link } from "react-router-dom";
import upButton from "../../images/icons/up_button.svg";

const Footer = () => {
  const goUpHandler = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-top page-width">
        <div className="aquastrong-logo">
          <Link to="/">
            <img
              className="aquastrong-image"
              src="https://aquastrong.it/wp-content/uploads/2024/10/96d6f2e7e1f705a.webp"
              alt="aquastrong"
            />
          </Link>
        </div>
        <nav className="footer-nav">
          <ul className="nav-list">
            {/* <li className="nav-item">
              <Link to="/news">Новости</Link>
            </li>
            <li className="nav-item">
              <Link to="/references">Референции</Link>
            </li> */}

            <li className="nav-item">
              <Link to="/rate-history">История курса</Link>
            </li>

            {/* <li className="nav-item">
              <Link to="/price-list">Прайс-лист</Link>
            </li> */}

            <li className="nav-item">
              <Link to="/balances">Складские остатки</Link>
            </li>
            <li className="nav-item">
              <Link to="/contacts">Контакты</Link>
            </li>
          </ul>
        </nav>

        <button className="up-button" onClick={() => goUpHandler()}>
          <img src={upButton} alt="go up" />
        </button>
      </div>

      <div className="footer-bottom border-top page-width">
        <span>© vodokomfort 2026. ООО ФИРМА «ВОДОКОМФОРТ»</span>
        <Link to="/privacy-policy">Политика конфиденциальности</Link>
      </div>
    </footer>
  );
};

export default Footer;
